/**
 * @generated SignedSource<<3d08eb070c736e51ace63cf1b016d5f6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentMethodSelect_viewer$data = {
  readonly clientToken: {
    readonly value: string | null;
  } | null;
  readonly id: string;
  readonly " $fragmentType": "PaymentMethodSelect_viewer";
};
export type PaymentMethodSelect_viewer$key = {
  readonly " $data"?: PaymentMethodSelect_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentMethodSelect_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentMethodSelect_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Token",
      "kind": "LinkedField",
      "name": "clientToken",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "value",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "ed3ca19b14c7548b9ecba60e8b9837c4";

export default node;
